<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    selected?: boolean;
    title?: string;
    subtitle?: string;
    mini?: boolean;
    extended?: boolean;
  }>(),
  {
    mini: false,
    extended: false,
  }
);

const emit = defineEmits<{
  "update:extended": [value: boolean];
}>();

const showModal = computed({
  get: () => props.extended,
  set: (value: boolean) => emit("update:extended", value),
});
</script>

<template>
  <div
    class="cursor-pointer hoverable-white overflow-hidden tile rounded"
    :class="[{ 'selected-item ': selected }, mini ? 'px-2 py-1' : 'p-2 ps-3']"
  >
    <div class="row gy-3">
      <div class="d-flex justify-content-between gap-2">
        <div
          class="flex-grow-1 overflow-hidden text-truncate d-flex gap-2 py-1"
          :class="{
            'align-items-center': mini,
          }"
        >
          <div class="col-auto"><slot name="icon"></slot></div>
          <div class="flew-grow-1 text-truncate">
            <div class="d-flex flex-column gap-2">
              <div class="d-flex text-truncate">
                <div v-if="title" class="col-12 text-truncate">
                  {{ title }}
                </div>
                <slot name="title"></slot>
              </div>
              <div v-if="!mini" class="w-100 d-flex" style="font-size: 10px">
                <span v-if="subtitle" class="me-2 text-grey">
                  {{ subtitle }}
                </span>
                <slot v-else name="subtitle"></slot>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto d-flex relative-position gap-1">
          <slot name="actions"></slot>
        </div>
      </div>
      <div
        v-if="!mini"
        class="justify-content-between align-items-center d-flex flex-row gap-2"
      >
        <slot class="col" name="footer"></slot>
        <slot class="col" name="more"></slot>
      </div>
    </div>

    <el-dialog
      @click.stop
      v-model="showModal"
      append-to-body
      :title="title"
      width="90%"
      :close-on-click-modal="false"
    >
      <slot name="extended"></slot>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.tile {
  background-color: var(--bs-white);
}
</style>
